// Checking if value from input is valid (If number, if value > 0, if number of digits after dot < 3)
export const isTipValid = tip => (
  (Number(tip) || Number(tip) === 0) && Number(tip) >= 0 && (tip.includes('.') && tip.split('.')[1].length) < 3
);
// Rounding tip
export const roundTip = tip => (parseFloat(tip) % 1 ? parseFloat(tip).toFixed(2) : parseFloat(tip));
// Formating tip value for input
export const formatTip = tip => (tip.includes('.') && tip.slice(0, 1) !== '.' ? tip : Number(tip));
